import React, { useState, useEffect, useRef } from 'react';

const Timer = ({ isActive, onResend, initialSeconds = 60 }) => {
  const [seconds, setSeconds] = useState(0);
  const hasStarted = useRef(false);

  useEffect(() => {
    if (isActive && !hasStarted.current) {
      setSeconds(initialSeconds);
      hasStarted.current = true;
    }
  }, [isActive, initialSeconds]);

  useEffect(() => {
    let timer;
    if (isActive && seconds > 0) {
      timer = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [seconds, isActive]);

  useEffect(() => {
    if (!isActive) {
      setSeconds(0);
      hasStarted.current = false;
    }
  }, [isActive]);

  const formatTime = (s) => {
    const min = String(Math.floor(s / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  const handleResendClick = () => {
    if (typeof onResend === 'function') {
      onResend();
      setSeconds(initialSeconds); 
      hasStarted.current = true; 
    }
  };

  return (
    <div>
      Didn't receive a code?{" "}
      {seconds === 0 ? (
        <span
          style={{
            color: "#244ECF",
            cursor: "pointer",
            fontWeight: 600,
          }}
          onClick={handleResendClick}
        >
          Resend now
        </span>
      ) : (
        <span
          style={{
            color: "#244ECF",
            cursor: "pointer",
          }}
        >
          {" "}
          Resend in{" "}
          <span
            className={
              seconds > 5 || seconds === 0 ? "" : "blink"
            }
            style={{
              fontWeight: 600,
              color: seconds <= 5 ? "#EE4B2B" : "#244ECF",
            }}
          >
            {formatTime(seconds)}
          </span>
        </span>
      )}
    </div>
  );
};

export default Timer;
